var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "477.901pt",
    height: "421.199pt",
    viewBox: "49.808 -639.749 477.901 421.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 89.952,
    ry: 89.952,
    transform: "translate(282.88 438.624) rotate(127.227)",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 116.253,
    ry: 116.252,
    transform: "translate(282.88 438.624) rotate(127.227)",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "none",
    strokeWidth: 0.182,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(250.87 536.737) scale(1 -1)",
    kerning: "auto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Integrations"))), /*#__PURE__*/React.createElement("path", {
    d: "M 326.593,412.05 L 282.987,484.454 L 240.283,411.858 L 326.593,412.05",
    fill: "none",
    strokeWidth: 0.808,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.528519 -0.848923 -0.848923 -0.528519 214.784 434.777)",
    kerning: "auto",
    fontSize: 10,
    strokeWidth: 1,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "none",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Point of Sale")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.501266 0.865295 0.865295 -0.501266 317.554 372.411)",
    kerning: "auto",
    fontSize: 10,
    strokeWidth: 1,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "none",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Payments Portal")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(254.855 490.333) scale(1 -1)",
    kerning: "auto",
    fontSize: 10,
    strokeWidth: 1,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "none",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Accounting")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(147.734 603.707) rotate(141.892)",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(147.661 617.45) scale(1 -1)",
    kerning: "auto",
    stroke: "none",
    strokeWidth: 0.151,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.785,
    y: 0
  }, "Student"), /*#__PURE__*/React.createElement("tspan", {
    x: -30.251,
    y: 16.341
  }, "Information"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.117,
    y: 32.682
  }, "System"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(412.158 603.706) rotate(141.892)",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(411.879 599.957) scale(1 -1)",
    kerning: "auto",
    stroke: "none",
    strokeWidth: 0.151,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.495,
    y: 0
  }, "Finance / GL"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(483.315 439.772) rotate(141.892)",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(483.239 452.363) scale(1 -1)",
    kerning: "auto",
    stroke: "none",
    strokeWidth: 0.151,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.82,
    y: 0
  }, "Library "), /*#__PURE__*/React.createElement("tspan", {
    x: -25.403,
    y: 16.341
  }, "Textbooks"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.03,
    y: 32.682
  }, "Assets"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(85.85 439.772) rotate(141.892)",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(85.777 436.023) scale(1 -1)",
    kerning: "auto",
    stroke: "none",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.396,
    y: 0
  }, "Nutrition"))), /*#__PURE__*/React.createElement("path", {
    d: "M 169.499,575.499 L 209.197,528.521",
    fill: "none",
    strokeWidth: 0.965,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 392.211,573.229 L 355.766,529.453",
    fill: "none",
    strokeWidth: 1.031,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(491.667 254.592) rotate(141.892)",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(491.747 250.86) scale(1 -1)",
    kerning: "auto",
    stroke: "none",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.628,
    y: 0
  }, "and more !"))), /*#__PURE__*/React.createElement("path", {
    d: "M 462.86,274.84 L 371.35,362.6",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.557,
    ry: 35.557,
    transform: "translate(147.734 300.324) rotate(141.892)",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "translate(147.634 296.575) scale(1 -1)",
    kerning: "auto",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.497,
    y: 0
  }, "Credit Cards"))), /*#__PURE__*/React.createElement("path", {
    d: "M 121.672,440.776 L 166.672,440.776",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 447.026,439.557 L 399.214,440.025",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175.534,322.62 L 206.268,350.201",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.84
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.23446e30fe9130bd99b8b75438991eca.svg";
export { ForwardRef as ReactComponent };